import React, { useCallback, useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { Button, Card, Container, Row, Col } from "react-bootstrap";
import { useParams } from "react-router-dom";
import { proformaGetByIdDetails } from "../../Redux/proformaReduce";
import jwt_decode from "jwt-decode";
import { t } from "react-multi-lang";
import Configuration from "../../configuration";

function DetailsImportProforma({ obj }) {
  const dispatch = useDispatch();
  const location = useParams();
  const idProforma = location.id;
  const token = localStorage.getItem("x-access-token");
  const decoded = jwt_decode(token);

  const [proforma, setProforma] = useState({});
  const [loader, setLoader] = useState(true);
  const [files, setFiles] = useState([]); // <-- plusieurs fichiers

  /* detailProforma*/
  const detailProforma = useCallback(
    async (idProforma) => {
      const dataProforma = await dispatch(proformaGetByIdDetails({ idProforma }));
      console.log(dataProforma)
      setProforma(dataProforma.payload);
      setLoader(false);
    },
    [dispatch]
  );

  useEffect(() => {
    detailProforma(idProforma);
  }, [idProforma, detailProforma]);



  return (
    <>
      {loader ? (
        <div className="loader-container">
          <div className="loader"></div>
        </div>
      ) : (
        <Container fluid>

          <Row>
            <Col md="12">
              <Button
                id="saveBL"
                className="btn-wd btn-outline mr-1 float-left"
                type="button"
                variant="info"
                onClick={() => window.history.back()}
              >
                <span className="btn-label">
                  <i className="fas fa-list"></i>
                </span>
                {t("list")}
              </Button>
            </Col>
          </Row>

          <Row>
            <Col md="12">
              <Card>
                <Card.Header>
                  <Card.Title as="h4">Détails Proforma</Card.Title>
                </Card.Header>
                <Card.Body>
                  <br />
                  <table className="table table-bordered">
                    <thead>
                      <tr className="table-info">
                        <th>Code Grossiste</th>
                        <th>Grossiste</th>
                        <th>Date d'enlevement</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>{proforma.Code_client}</td>
                        <td>{proforma.Raison_sociale}</td>
                        <td>{proforma.date_enlevement}</td>
                      </tr>
                    </tbody>
                  </table>
                  <br />
                  <Card.Title as="h4">Détails Proforma</Card.Title>
                  {proforma.reste &&
                    <>
                      <h3><strong>Reste à livrer</strong></h3>
                      <iframe
                        src={`${Configuration.BACK_BASEURL}proforma/${proforma.reste}`}
                        width="100%"
                        height="600px"
                        style={{ border: "none", marginBottom: "20px" }}
                        title={`PDF Viewer reste`}
                      ></iframe></>}
                  {

                    proforma && proforma.files.length > 0 && (
                      <div>
                        {proforma.files.map((f, idx) => (
                          <>
                            <h3><strong>{f.num_commande}</strong></h3>
                            <iframe
                              key={idx}
                              src={`${Configuration.BACK_BASEURL}proforma/${f.file}`}
                              width="100%"
                              height="600px"
                              style={{ border: "none", marginBottom: "20px" }}
                              title={f.num_proforma}
                            ></iframe>
                          </>

                        ))}
                      </div>
                    )

                  }

                  <div className="clearfix"></div>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      )}
    </>
  );
}

export default DetailsImportProforma;
